import * as React from 'react';
import { Reference } from '@fluentai/react-copilot';
import { Announced } from 'office-ui-fabric-react';
import { useLinkRefenceStyles } from './LinkReference.styles';

/** Links to the referenced content. Fetches page title of Role or Profile links. */
export const LinkReference = (props: {
  url: string;
  index: number;
  linkText: string;
  handleCitationClick: (url: string) => void;
}) => {
  const [announceText, setAnnounceText] = React.useState('');
  const styles = useLinkRefenceStyles();

  const onClick = () => {
    setAnnounceText(`${props.linkText} page`);
    props.handleCitationClick(props.url);
  };

  return (
    <>
      <Reference
        onClick={() => onClick()}
        layout="popover"
        index={props.index}
        label={props.linkText || props.url}
        style={{ cursor: 'pointer' }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            // Handle the Enter key press here
            onClick();
          }
        }}
        tabIndex={0}
        role="link"
        aria-label={`${props.index} ${props.linkText}`}
      />
      {announceText && (
        <Announced aria-live="assertive" className={styles.srOnly} message={announceText ? announceText : ''} />
      )}
    </>
  );
};
